import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ReportDom from "../../../../components/common/ReportDom";
import ManufacturingVoucherBody from "./ManufacturingVoucherBody";
import ManufacturingVoucherBodyDesignA from "./ManufacturingVoucherBodyDesignA";
import { fetchSingleInstitutionDetails } from "../../../../store/commonThunks/lookups";

export default function ManufacturingPrint({ id }) {
  const [ready, setReady] = useState(false);
  const dispatch = useDispatch();
  const { institutionData } = useSelector((state) => state.lookups);
  const isDesignA = institutionData?.print_template === "design_a";

  // This is reached as a standalone print route (via PrintRenderer, a fresh
  // tab/page load) -- institutionData.print_template can't be assumed to
  // already be loaded, or Design A silently falls back to legacy.
  useEffect(() => {
    dispatch(fetchSingleInstitutionDetails()).finally(() => setReady(true));
  }, [dispatch]);

  if (!ready) return null;

  if (isDesignA) {
    return <ReportDom mode="no-title" renderTable={() => <ManufacturingVoucherBodyDesignA mf_id={id} />} />;
  }

  return (
    <ReportDom
      renderTable={() => <ManufacturingVoucherBody mf_id={id} printMode />}
    />
  );
}
